import script from "./internalLink.vue?vue&type=script&lang=js"
export * from "./internalLink.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__